import React from "react";
import cbmsTitleImage from "../../../../../assets//images/home/carousel-slider/cbms-title-for-slider.png";
import CarouselCaption from "./carouselCaption";

const CarouselItem = ({ item, count }) => {
  const handleLogout = () => {
    document.cookie =
      "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    window.history.pushState(null, "", `/portal/admin/login`);
    window.location.reload();
  };
  return (
    <div className={`carousel-item ${count === 0 && " active"}`}>
      <img
        className="d-block w-100 slider-image"
        src={`data:image/jpg;base64,${item.sliderBase64}`}
        alt={item.sliderTag}
      />
      <div className="carousel__overlay"></div>
      <CarouselCaption>
        <img className="cbms-title-for-slider" src={cbmsTitleImage} alt="" />
        <div className="d-flex flex-column flex-xl-row justify-content-center my-1 my-sm-3 mb-xl-5">
          <div className="d-flex justify-content-center">
            <button onClick={handleLogout} className="cbms-btn login-btn mr-2">
              Logout
            </button>
          </div>
        </div>
      </CarouselCaption>
    </div>
  );
};

export default CarouselItem;
